module.exports = __webpack_public_path__ + "static/media/share-whatsapp.e346e5a1.svg";